module.exports = __webpack_public_path__ + "img/body-bg.61b2efa7.png";